import { SetStateAction, useState } from 'react';
import CustomSelect from '../../../../../components/common/SelectField';
import { Grid, MenuItem, Tooltip } from '@mui/material';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { TableInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import moment from 'moment';
import AutocompleteMuiCustom from '../../../../../components/common/AutocompleteMuiCustom';
import { TimePicker } from '@mui/x-date-pickers';
import {
  AddIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import formatDate from '../../../../../components/common/formatDate';
import { convToTime } from '../../../../../utils/helpers';
import CustomMobileTimePickerMui from '../../../../../components/common/CustomMobileTimePickerMui';
// import Operator from '../../../../components/Operator';
import OperationSelect from '../OperationSelect';
import { useQuery } from '../../../../../hooks/UseQuery';
interface IProps {
  moduleData: any;
  isView: boolean;
  handleSumbit: any;
  machineData: any;
  // autoCompleteMachineValue: any;
  handelDeleteRows: any;
  isOpenPopup: any;
  setIsOpenPopup: any;
  setPartIdx: any;
  setIsOpenPopupRejections: any;
  setRejectionsIndx: any;
}

const getTotalRjection = (process: any) => {
  const totalRejectionQty = process?.reasons_for_rej.reduce(
    (sum: number, item: any) => sum + +item.rej_qty,
    0
  );
  process.rejection_qty = totalRejectionQty;
  return totalRejectionQty;
};
const isLeapYear = (year: number) => {
  if ((0 == year % 4 && 0 != year % 100) || 0 == year % 400) return true;
  else return false;
};
const TBody = ({
  moduleData,
  isView,
  handleSumbit,
  machineData,
  // autoCompleteMachineValue,
  handelDeleteRows,
  isOpenPopup,
  setIsOpenPopup,
  setPartIdx,
  setIsOpenPopupRejections,
  setRejectionsIndx,
}: IProps) => {
  const [render, setRender] = useState(false);
  const date = useQuery('annual_date');
  const arr: any = date?.split('-');
  const month = arr[0];
  const year = arr[1];
  const monthNames: any = {
    JAN: ['01', '31'],
    FEB: isLeapYear(+year) ? ['02', '29'] : ['02', '28'],
    MAR: ['03', '31'],
    APR: ['04', '30'],
    MAY: ['05', '31'],
    JUN: ['06', '30'],
    JUL: ['07', '31'],
    AUG: ['08', '31'],
    SEP: ['09', '30'],
    OCT: ['10', '31'],
    NOV: ['11', '30'],
    DEC: ['12', '31'],
  };
  const monthIndex = monthNames[month][0];
  const maxDays = monthNames[month][1];
  return (
    <>
      <tbody>
        {moduleData &&
          moduleData.processes.map((process: any, index: number) => (
            <tr key={index + 'module data'}>
              <td width={'100px'} style={{ fontWeight: 'bold' }}>
                {index + 1}
              </td>
              <td style={{ minWidth: '200px' }}>
                <DatePickerMui
                  label=""
                  value={moment(process.process_date || '')}
                  onChange={(date) => {
                    process.process_date = date;
                    setRender((prev) => !prev);
                  }}
                  minDate={moment(new Date(`${monthIndex}/01/${year}`))}
                  maxDate={moment(new Date(`${monthIndex}/${maxDays}/${year}`))}
                />
              </td>
              <td style={{ width: '250px', minWidth: '250px' }}>
                {isView ? (
                  process?.part_id &&
                  process?.part_id?.part_name +
                    ' & ' +
                    process.part_id?.part_number
                ) : (
                  <Grid container xs={12} direction="row" alignItems={'center'}>
                    <Grid item xs={10}>
                      <p
                        style={{
                          fontSize: '1.2rem',
                        }}
                      >
                        {typeof process?.part_id === 'object' &&
                        process?.part_id !== null
                          ? process?.part_id?.part_name +
                            ' & ' +
                            process.part_id?.part_number
                          : (process?.partNumber &&
                              process?.partName +
                                ' & ' +
                                process?.partNumber) ||
                            ''}
                        {!process?.part_id && 'Pick Part No.'}
                      </p>
                    </Grid>

                    {process.part_id ? (
                      <Grid item xs={2}>
                        <RemoveIconButton
                          tooltipTitle="remove part"
                          onClick={() => {
                            process.part_id = null;
                            process.partNumber = null;
                            process.partName = null;
                            process.customer_name = null;
                            process.area = null;
                            setRender((prev) => !prev);
                          }}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={2}>
                        <AddIconButton
                          tooltipTitle="add part"
                          onClick={() => {
                            setIsOpenPopup(true);
                            setPartIdx(index);
                          }}
                        />
                      </Grid>
                    )}
                  </Grid>
                )}
              </td>
              <td>{process?.customer_name}</td>
              <td>{process?.area}</td>
              <td
                style={{
                  width: '280px',
                  minWidth: '280px',
                  textAlign: 'center',
                }}
              >
                <Grid container xs={12} direction="row" alignItems={'center'}>
                  <Grid item xs={10}>
                    <p
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Click on + icon for reason and qty
                    </p>
                  </Grid>
                  <Grid item xs={2}>
                    <AddIconButton
                      tooltipTitle="add reasons and qty"
                      onClick={() => {
                        setIsOpenPopupRejections(true);
                        setRejectionsIndx(index);
                      }}
                    />
                  </Grid>
                </Grid>
              </td>
              <td>{getTotalRjection(process)}</td>
              <td>
                <TableInput
                  isView={isView}
                  name="prod_qty"
                  type="number"
                  value={process.prod_qty}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '200px' }} colSpan={2}>
                {((process.rejection_qty * 1000000) / process.prod_qty).toFixed(
                  2
                )}
              </td>
              {!isView && (
                <td style={{ minWidth: '100px' }}>
                  <DeleteIconButton
                    tooltipTitle={'delete'}
                    onClick={() => handelDeleteRows(index)}
                  />
                </td>
              )}
            </tr>
          ))}
      </tbody>
    </>
  );
};

export default TBody;
